(() => {
  if (window.__sohimiOrderAttributionInstalled || typeof window.fetch !== 'function') return;
  window.__sohimiOrderAttributionInstalled = true;

  const storageKey = 'sohimi_order_attribution_v1';
  const maxAgeMs = 30 * 24 * 60 * 60 * 1000;
  const maxLength = 100;

  function clean(value) {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase().replace(/[^a-z0-9._-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, maxLength);
  }

  function cleanPath(value) {
    if (typeof value !== 'string') return '';
    return value.split(/[?#]/, 1)[0].trim().slice(0, maxLength);
  }

  function readStored() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (!stored || typeof stored !== 'object' || Date.now() - Number(stored.updatedAt || 0) > maxAgeMs) return null;
      return stored;
    } catch (_) {
      return null;
    }
  }

  function saveStored(value) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (_) {}
  }

  function readIncoming() {
    const url = new URL(window.location.href);
    const creator = clean(url.searchParams.get('creator') || url.searchParams.get('influencer') || url.searchParams.get('partner'));
    const source = clean(url.searchParams.get('utm_source'));
    const medium = clean(url.searchParams.get('utm_medium'));
    const campaign = clean(url.searchParams.get('utm_campaign'));
    const content = clean(url.searchParams.get('utm_content'));

    if (!source && !creator && !campaign) return null;

    return {
      source,
      medium,
      campaign,
      content,
      creator,
      landingPath: cleanPath(url.pathname),
      recordedAt: Date.now(),
    };
  }

  function cartAttributes(state) {
    const attributes = { __attr_version: '2' };
    const first = state.first;
    const last = state.last || first;

    if (first && last) {
      attributes.__attr_first_source = first.source || '';
      attributes.__attr_first_medium = first.medium || '';
      attributes.__attr_first_campaign = first.campaign || '';
      attributes.__attr_first_content = first.content || '';
      attributes.__attr_first_creator = first.creator || '';
      attributes.__attr_first_landing = first.landingPath || '';
      attributes.__attr_last_source = last.source || '';
      attributes.__attr_last_medium = last.medium || '';
      attributes.__attr_last_campaign = last.campaign || '';
      attributes.__attr_last_content = last.content || '';
      attributes.__attr_last_creator = last.creator || '';
      attributes.__attr_last_landing = last.landingPath || '';
    }

    if (state.blogFirst && state.blogLast) {
      attributes.__attr_blog_first = state.blogFirst.path;
      attributes.__attr_blog_last = state.blogLast.path;
      attributes.__attr_blog_last_target = state.blogLast.targetPath;
    }

    return attributes;
  }

  async function updateCart(attributes) {
    const root = window.Shopify?.routes?.root || '/';
    const endpoint = `${root.replace(/\/$/, '')}/cart/update.js`;
    try {
      await window.fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
        keepalive: true,
      });
    } catch (_) {}
  }

  function isBlogArticle(pathname) {
    return /^\/blogs\/[^/]+\/[^/]+\/?$/i.test(pathname);
  }

  function isCommerceDestination(pathname) {
    return /^\/(products|collections)\/[^/]+/i.test(pathname);
  }

  function readBlogAssist(event) {
    const blogPath = cleanPath(window.location.pathname);
    if (!isBlogArticle(blogPath)) return null;

    const anchor = event.target?.closest?.('a[href]');
    if (!anchor) return null;

    let target;
    try {
      target = new URL(anchor.href, window.location.href);
    } catch (_) {
      return null;
    }

    if (target.origin !== window.location.origin || !isCommerceDestination(target.pathname)) return null;

    return {
      path: blogPath,
      targetPath: cleanPath(target.pathname),
      linkText: String(anchor.textContent || anchor.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ').slice(0, 80),
      recordedAt: Date.now(),
    };
  }

  function persist(state) {
    state.updatedAt = Date.now();
    saveStored(state);
    updateCart(cartAttributes(state));
  }

  let state = readStored() || {};
  const incoming = readIncoming();
  if (incoming) {
    state.first = state.first || incoming;
    state.last = incoming;
    persist(state);
  }

  document.addEventListener('click', (event) => {
    const assist = readBlogAssist(event);
    if (!assist) return;

    state = readStored() || state || {};
    state.blogFirst = state.blogFirst || assist;
    state.blogLast = assist;
    persist(state);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'blog_product_click',
      blog_path: assist.path,
      target_path: assist.targetPath,
      link_text: assist.linkText,
    });
  }, true);
})();
